module.exports = __webpack_public_path__ + "assets/img/logo-nav.f25df34d.png";